import TextMessage from './textMessage.view';

export default TextMessage;
